<script setup lang="ts">
  import { computed } from "vue";
  import { Avatar, Text } from "@ui-kit";

  const { displayName, description } = defineProps<{
    displayName?: string;
    description?: string;
  }>();

  const executerInitials = computed(() => {
    const [firstName = "", lastName = ""] = displayName?.split(" ") || [];

    return { firstName, lastName };
  });
</script>

<template>
  <div class="order-card-executer" data-testid="order-card-executer">
    <Avatar :first-name="executerInitials.firstName" :last-name="executerInitials.lastName" />
    <div class="info">
      <Text font="body-medium-16" data-testid="name">{{ displayName || $t("Не назначен") }}</Text>
      <Text font="body-regular-14" color="secondary" data-testid="description">
        {{ description || "..." }}
      </Text>
    </div>
  </div>
</template>

<style scoped>
  .order-card-executer {
    display: flex;
    gap: 16px;
    align-items: center;

    & :deep(.avatar) {
      flex-shrink: 0;
      width: 36px;
      height: 36px;
    }

    .info {
      display: flex;
      flex-direction: column;
      gap: 2px;
      overflow: hidden;

      & :deep(.text) {
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
</style>
